import React from 'react';
import Area from './Area';
import squidImage from '../../../../images/features/saga/squids.jpg';
import riceFieldImage from '../../../../images/features/saga/rice_fields.jpg';
import aritaYakiImage from '../../../../images/features/saga/arita_yaki.jpg';
import kinoHotSpringImage from '../../../../images/features/saga/kino_hot_spring.jpg';
import balloonChallengeImage from '../../../../images/features/saga/balloon_challenge.jpg';
import sagaCastleImage from '../../../../images/features/saga/saga_castle.jpg';
import yoshinogariParkImage from '../../../../images/features/saga/yoshinogari_park.jpg';
import hishiImage from '../../../../images/features/saga/hishi.jpg';
import Typography from './StyledTypography';
import SectionContainer from './SectionContainer';

const AREAS = [
  {
    number: '01',
    area: '玄海・海の幸エリア',
    city: '唐津市、玄海町',
    description: (
      <>
        <Typography>
          県の北西に位置し、漁業や農業、海のレジャーが盛んな地域です。地形を活かした絶景の棚田や滝などが豊富にあり、新鮮な魚を堪能することできます。
        </Typography>
        <Typography>
          また、他にも歴史を感じる「唐津城」や、重要文化財に指定された唐津神社で行われる「唐津くんち」というお祭りなどもあるエリアになっています。
        </Typography>
      </>
    ),
    images: [
      {
        src: squidImage,
        title: 'イカの生干しの風景（唐津市呼子町）',
      },
      {
        src: riceFieldImage,
        title: '浜野浦の棚田（玄海町）',
      },
    ],
  },
  {
    number: '02',
    area: 'やきもの・温泉エリア',
    city: '伊万里市、武雄市、鹿島市、嬉野市、有田町、太良町',
    description: (
      <>
        <Typography>
          県の南西に位置し、「伊万里焼」「有田焼」などの有名な焼き物や「嬉野温泉」などがあります。焼き物の窯元や施設、美しい庭園や寺院などが多く、ゆったり楽しむことができるエリアです。
        </Typography>
        <Typography>
          さらに食べ物については、名産の「竹崎かに」や「佐賀牛」の他に、とうふ・のり・お茶などの生産が豊富です。
        </Typography>
      </>
    ),
    images: [
      {
        src: aritaYakiImage,
        title: '有田焼（有田町）',
      },
      {
        src: kinoHotSpringImage,
        title: '嬉野温泉（嬉野市）',
      },
    ],
  },
  {
    number: '03',
    area: '有明海・城下町エリア',
    city: '佐賀市、多久市、小城市、大町町、江北町、白石町',
    description: (
      <>
        <Typography>
          県の中央部に位置し、アジア最大級の国際熱気球大会「佐賀インターナショナルバルーンフェスタ」や「肥前びーどろ」、干潮時には全国の干潟面積の約4割を占める広大な干潟「有明海」などがあるエリアです。
        </Typography>
        <Typography>
          また、こちらの佐賀城を中心とした城下町なこともあり、当時の生活や文化を感じることができる施設や住宅が豊富にあります。
        </Typography>
      </>
    ),
    images: [
      {
        src: balloonChallengeImage,
        title: 'SAGAバルーンチャレンジシリーズ（佐賀市）',
      },
      {
        src: sagaCastleImage,
        title: '佐賀城本丸歴史館（佐賀市）',
      },
    ],
  },
  {
    number: '04',
    area: '古代・吉野ヶ里エリア',
    city: '鳥栖市、神埼市、吉野ヶ里町、基山町、上峰町、みやき町',
    description: (
      <>
        <Typography>
          県の東側に位置し、日本最大規模の弥生時代の環壕集落跡「吉野ヶ里歴史公園」や、昔ながらのクリークや住宅が残っており、古代の趣を感じることができるエリアです。
        </Typography>
        <Typography>
          クリークで栽培されている秋の風物詩、「菱の実取り」も魅力の一つです。
        </Typography>
        <Typography>
          また、自然公園や温泉などもあり、幅広い世代が楽しめる場所になっております。
        </Typography>
      </>
    ),
    images: [
      {
        src: yoshinogariParkImage,
        title: '吉野ヶ里歴史公園（神埼市・吉野ヶ里町）',
      },
      {
        src: hishiImage,
        title: '菱の実とり（県内各地）',
      },
    ],
  },
];

const Areas = () => {
  return (
    <SectionContainer>
      {AREAS.map((area) => (
        <Area key={area.number} {...area} />
      ))}
    </SectionContainer>
  );
};

export default Areas;
